import type { Ref } from "react";
import type { ScrollViewInstance } from "react-native";
import { ScrollView, type ScrollViewProps } from "react-native";

type Props = ScrollViewProps & {
  className?: string;
  ref?: Ref<ScrollViewInstance>;
  /** Native only: the web has no software keyboard to make room for. */
  bottomOffset?: number;
  extraKeyboardSpace?: number;
};

export function SheetScrollView(
  { bottomOffset: _bottomOffset, extraKeyboardSpace: _extraKeyboardSpace, ...props }: Props,
) {
  return <ScrollView {...props} />;
}
